import { createStore } from 'vuex'

const store = createStore({
  state: {
    theme: localStorage.getItem('theme') || 'light',
    language: localStorage.getItem('language') || 'en',
    isMenuOpen: false
  },
  mutations: {
    SET_THEME(state, theme) {
      state.theme = theme
      localStorage.setItem('theme', theme)
      
      // Apply theme to document
      if (theme === 'dark') {
        document.documentElement.classList.add('dark')
        document.body.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
        document.body.classList.remove('dark')
      }
    },
    SET_LANGUAGE(state, language) {
      state.language = language
      localStorage.setItem('language', language)
    },
    TOGGLE_MENU(state) {
      state.isMenuOpen = !state.isMenuOpen
    },
    SET_MENU_OPEN(state, isOpen) {
      state.isMenuOpen = isOpen
    }
  },
  actions: {
    toggleTheme({ commit, state }) {
      const newTheme = state.theme === 'light' ? 'dark' : 'light'
      commit('SET_THEME', newTheme)
    },
    setTheme({ commit }, theme) {
      commit('SET_THEME', theme)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    toggleMenu({ commit }) {
      commit('TOGGLE_MENU')
    },
    setMenuOpen({ commit }, isOpen) {
      commit('SET_MENU_OPEN', isOpen)
    }
  },
  getters: {
    isDarkMode: state => state.theme === 'dark',
    currentLanguage: state => state.language,
    isKhmer: state => state.language === 'km',
    isMenuOpen: state => state.isMenuOpen
  }
})

// Initialize theme on store creation
store.dispatch('setTheme', store.state.theme)

export default store 